export const locales = ['en', 'fr', 'tr', 'de', 'es', 'it', 'ru', 'ar', 'fa'] as const;
export type Locale = (typeof locales)[number];

export const namespaces = ['common', 'home', 'forms', 'contact', 'booking', 'about', 'treatments', 'countries', 'metadata', 'dental_implants', 'all-on-4', 'dental_veneers', 'hollywood-smile', 'root-canal', 'teeth-whitening', 'testimonials'] as const;
export type Namespace = (typeof namespaces)[number];

export const defaultLocale: Locale = 'en';

export function isValidLocale(value: string): value is Locale {
  return (locales as readonly string[]).includes(value);
}

export function resolveLocale(value: string | undefined): Locale {
  return value && isValidLocale(value) ? value : defaultLocale;
}

export const rtlLocales = ['ar', 'fa'] as const;

export function isRTLLanguage(locale: string): boolean {
  return rtlLocales.includes(locale as any);
}

export const languageNames: Record<Locale, string> = {
  en: 'English',
  fr: 'Français',
  tr: 'Türkçe',
  de: 'Deutsch',
  es: 'Español',
  it: 'Italiano',
  ru: 'Русский',
  ar: 'العربية',
  fa: 'فارسی'
};

export const languageFlags: Record<Locale, string> = {
  en: '🇬🇧',
  fr: '🇫🇷',
  tr: '🇹🇷',
  de: '🇩🇪',
  es: '🇪🇸',
  it: '🇮🇹',
  ru: '🇷🇺',
  ar: '🇸🇦',
  fa: '🇮🇷'
};